import { getGameLiffId } from '@/config/liff';

const NAV_ICON_LIST = [
  { name: "yama", icon: require("@/assets/images/yama/yama-icon.png") },
  { name: "relateds", icon: require("@/assets/images/related-icon.png") },
  { name: "exhibits", icon: require("@/assets/images/exhibit-icon.png") },
  { name: "souls", icon: require("@/assets/images/soul-icon.png") },
  { name: "times", icon: require("@/assets/images/time-icon.png") },
  { name: "hints", icon: require("@/assets/images/hint-icon.png") },
  { name: "records", icon: require("@/assets/images/yama/yama-icon.png") }
];

export const getToken = type => {
  return getGameLiffId(type);
};

export const getNavIconList = () => NAV_ICON_LIST;
